// code for excute api
module.exports = {
    INSERT1: 1,
    UPDATE1: 2,
    SETENABLED: 3,
    SETENABLEDIOC: 4,
    DELFAKE1 :10,
    DELFAKELIST :11,
    DELREAL1 :12,
    DELREALLIST :13, 
    RESTORE1  :14, 
    RESTORELIST  :15, 
    SELECT1 : 21,
    SELECTACTIVE : 22,
    SELECTDELETED : 23,
    SELECTLIST : 24,
    CHECKEXISTSID:25,
    CHECKEXISTSNAME:26,
    SELECTACTIVEPAGING : 22,
    SELECTDELETEDPAGING: 23,
    SELECTBASICLIST: 24,

    SELECTMAPINFO: 27,
    SELECTEXPORT: 30,

    /*
        actionCode = 1  -- insert
        actionCode = 2  -- update
        actionCode = 10 -- delete fake
        actionCode = 11 -- delete fake list
        actionCode = 12 -- delete real
        actionCode = 13 -- delete real list
        actionCode = 14 -- restore (chỉ áp dụng khi delete fake)
        actionCode = 15 -- restore list (chỉ áp dụng khi delete fake)
        actionCode = 21 -- select by id
        actionCode = 22 -- select list is_delete = 0
        actionCode = 23 -- select list is_delete = 1
        actionCode = 24 -- select basic list where is_delete = 0
        actionCode = 25 -- check exists id
        actionCode = 26 -- check exists name
        actionCode = 28 -- select hinh_anh theo list
        actionCode = 30 -- select data for export excel
    */
}
